import React, { Component } from 'react'
import { List, Icon, Toast } from 'antd-mobile'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import {
  fetchHotword,
  fetchSearchGoods as fetchSearchGoodsApi,
} from '@/api/search'
import { Goods } from '@/components/goods'
import { setHeader } from '@/util/set-header'
import SearchHeader from '@/components/search-header'
import { getAuth } from '@/util/storage'
import './search.less'
const { Item } = List

const historyWordsHelper = {
  clearAllHistoryWord() {
    localStorage.setItem('historyWords', '[]')
  },
  clearHistoryWord(keyword: string) {
    const historyWords = this.getHistoryWords()
    historyWords.splice(historyWords.indexOf(keyword), 1)
    localStorage.setItem('historyWords', JSON.stringify(historyWords))
  },
  setHistoryWords(keyword: string) {
    const historyWords = this.getHistoryWords()
    if (~historyWords.indexOf(keyword)) {
      historyWords.splice(historyWords.indexOf(keyword), 1)
    }
    historyWords.unshift(keyword)

    localStorage.setItem('historyWords', JSON.stringify(historyWords))
  },
  getHistoryWords() {
    return JSON.parse(localStorage.getItem('historyWords') || '[]')
  },
}

const mapStateToProps = (state: any) => {
  return {
    depot_id: state.depot.id,
  }
}
@(connect(mapStateToProps) as any)
export class Search extends Component<any, any> {
  state = {
    keyword: '',
    hotwords: [],
    searched: false,
    isHasResult: true,
    historyHeight: 0,
    historyWords: [],
    getGoods: () => {},
  }
  historyEl!: HTMLElement
  setKeyword!: any

  UNSAFE_componentWillMount() {
    if (window.WebViewBridge) {
      window.WebViewBridge?.shouldShowTabBar?.call(window.WebViewBridge, false)
    } else if (window.webkit) {
      window.webkit.messageHandlers.shouldShowTabBar.postMessage(false)
    }
    setHeader({ nav: <div /> })
  }
  componentDidMount() {
    const historyWords = historyWordsHelper.getHistoryWords()
    this.setState({ historyWords })
    this.setHistoryHeight()
    this.getHotword()

    window.addEventListener('resize', this.setHistoryHeight)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.setHistoryHeight)
  }
  setHistoryHeight = () => {
    try {
      const historyHeight =
        document.documentElement.clientHeight -
        (ReactDOM.findDOMNode(this.historyEl) as HTMLElement).offsetTop
      this.setState({ historyHeight })
    } catch (e) {}
  }

  keywordClick = (keyword: string) => {
    this.setKeyword(keyword)
    historyWordsHelper.setHistoryWords(keyword)
    const historyWords = historyWordsHelper.getHistoryWords()
    this.setState({ historyWords })
    this.search(keyword)
  }
  clearHistory = (keyword?: string) => {
    if (keyword) {
      historyWordsHelper.clearHistoryWord(keyword)
    } else {
      historyWordsHelper.clearAllHistoryWord()
    }
    const historyWords = historyWordsHelper.getHistoryWords()
    this.setState({ historyWords })
  }
  getHotword = async () => {
    const { data } = await fetchHotword()
    this.setState({ hotwords: data.data }, this.setHistoryHeight)
  }
  onClear = () => {
    this.setState({
      searched: false,
    })
  }
  search = async (keyword: string) => {
    if (!keyword) {
      return
    }
    historyWordsHelper.setHistoryWords(keyword)
    const { depot_id } = this.props
    const params = {
      keyword,
      type: 'goods',
      depot_id,
      auth: getAuth(),
    }
    this.setState({
      keyword,
      searched: true,
      isHasResult: true,
      getGoods: async (page: any) => {
        const { data, code, msg }: any = await fetchSearchGoodsApi({
          ...params,
          ...page,
        })
        if (code !== 'SUCCESS') {
          Toast.info(msg)
          return
        }
        if (data.length <= 0 && page.page === 1) {
          this.setState({ isHasResult: false })
        }
        return data
      },
    })
  }
  render() {
    const {
      hotwords,
      searched,
      historyHeight,
      historyWords,
      getGoods,
      isHasResult,
      keyword,
    } = this.state

    const { keywordClick, clearHistory, search, onClear } = this
    return (
      <div className="search-p-wrap">
        <SearchHeader
          onSearch={search}
          change={(cb: any) => (this.setKeyword = cb)}
          onClear={onClear}
        />
        <div className="body">
          {searched ? (
            isHasResult ? (
              <Goods key={keyword} api={getGoods} />
            ) : (
              <div className="no-result flex-lvc">
                <div>
                  <img src="/public/assets/img/error.png" alt="" />
                  <div className="text-center">没有“{keyword}”的搜索结果~</div>
                </div>
              </div>
            )
          ) : (
            <React.Fragment>
              <div className="hotwords">
                <div className="title">今日热搜</div>
                <div className="hotwords-content">
                  {hotwords &&
                    hotwords.map(hotword => (
                      <span key={hotword} onClick={() => keywordClick(hotword)}>
                        {hotword}
                      </span>
                    ))}
                </div>
              </div>
              <div className="space"></div>
              <div
                className="history"
                ref={el => (this.historyEl = el as HTMLElement)}
                style={{ height: historyHeight, overflow: 'auto' }}
              >
                {historyWords.length > 0 && (
                  <List
                    renderHeader={<span className="font-7">历史搜索</span>}
                    renderFooter={
                      <span className="font-7" onClick={() => clearHistory()}>
                        清空搜索历史
                      </span>
                    }
                    className="list"
                  >
                    {historyWords.map((word: any) => (
                      <Item
                        className="font-7"
                        extra={
                          <Icon
                            type="cross"
                            onClick={e => {
                              e.stopPropagation()
                              clearHistory(word)
                            }}
                          />
                        }
                        key={word}
                        onClick={() => keywordClick(word)}
                      >
                        {word}
                      </Item>
                    ))}
                  </List>
                )}
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    )
  }
}

export default Search
